import { useMutation, useQueryClient } from "react-query";

import axios from "axios";

import { CUTOFF_SOURCES_QUERY_KEY } from "./useCutoffSources";

///hook to fetch ipdb fields
export default function useDeleteCutoffSource() {
  const dataServiceEndPoint = process.env.REACT_APP_DATA_RS_ROOT;
  const geologyEndPoint = `${dataServiceEndPoint}/api/v1/geology`;

  const queryClient = useQueryClient();
  const deleteRecord = async (source: string) => {
    // Here you would make your HTTP request or whatever your deletion logic needs to be
    const response = await axios.delete(
      `${geologyEndPoint}/ipdb/playto3d/sources/cutoff/${encodeURIComponent(source)}`
    );

    if (response.status !== 200) {
      throw new Error("Problem deleting record");
    }
  };
  return useMutation(deleteRecord, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(CUTOFF_SOURCES_QUERY_KEY);
    }
  });
}
